import { render, staticRenderFns } from "./viewTreatmentReport.vue?vue&type=template&id=0842df04&scoped=true&"
import script from "./viewTreatmentReport.vue?vue&type=script&lang=js&"
export * from "./viewTreatmentReport.vue?vue&type=script&lang=js&"
import style0 from "./viewTreatmentReport.vue?vue&type=style&index=0&id=0842df04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0842df04",
  null
  
)

export default component.exports